import { render, staticRenderFns } from "./LkNotificationsBroadcastsDialog.vue?vue&type=template&id=1941988b&scoped=true"
import script from "./LkNotificationsBroadcastsDialog.vue?vue&type=script&lang=js"
export * from "./LkNotificationsBroadcastsDialog.vue?vue&type=script&lang=js"
import style0 from "./LkNotificationsBroadcastsDialog.vue?vue&type=style&index=0&id=1941988b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1941988b",
  null
  
)

export default component.exports